import Vue from 'vue'
import { GetterTree, MutationTree } from "vuex"

import { getResource } from "~/utils/store"
import { RootState } from "~/store/store.types"

import { AvailabilityRatesState, AvailabilityRateResource } from "./availability-rates.types"

export const state = (): AvailabilityRatesState => ({
  data: {},
  filters: {}
})

export const getters: GetterTree<AvailabilityRatesState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<AvailabilityRateResource>(state, id, rootGetters, included)
  }
}

export const mutations: MutationTree<AvailabilityRatesState> = {
  SET_AVAILABILITY_RATE (state, availabilityRate: AvailabilityRateResource) {
    const { id } = availabilityRate

    Vue.set(state.data, id, availabilityRate)
  }
}
